import { useTranslation, type Locale } from '@/lib/i18n';

export function LanguageToggle() {
  const { locale, setLocale } = useTranslation();

  const toggleLanguage = () => {
    const newLocale: Locale = locale === 'pt-BR' ? 'en' : 'pt-BR';
    setLocale(newLocale);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="px-4 py-2 rounded-lg bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors font-medium text-gray-900 dark:text-white"
      aria-label="Toggle language"
    >
      {locale === 'pt-BR' ? '🇧🇷 PT' : '🇺🇸 EN'}
    </button>
  );
}
